import permissions from '../../permissions'

const MONITORING_MANAGEMENT_PMC_LIST = [
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.LIST,
    tag: permissions.MONITORING_MANAGEMENT_PMC.LIST,
  },
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.MANAGE,
    tag: permissions.MONITORING_MANAGEMENT_PMC.MANAGE,
  },
]

export default MONITORING_MANAGEMENT_PMC_LIST
